module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DSelect', {
    attrs: {
      "items": _vm.itemsFiltered,
      "show": _vm.show,
      "itemsSelected": _vm.itemsSelected,
      "placeholder": _vm.placeholder,
      "isDeleteAllAnOption": false
    },
    on: {
      "update": _vm.update,
      "multiPaste": _vm.onMultiPaste,
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [_vm._v("En person må have max seks kompetencer")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6822d0e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningDSelect.vue
// module id = 1976
// module chunks = 1